import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { wizApiRef, WizClient } from './api';

export const backstagePluginWizPlugin = createPlugin({
  id: 'wiz',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: wizApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new WizClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const EntityCicdScansPage = backstagePluginWizPlugin.provide(
  createComponentExtension({
    name: 'EntityCicdScans',
    component: {
      lazy: () =>
        import('./components/EntityCicdScans').then(
          m => m.EntityCicdScans,
        ),
    },
  }),
);

export const EntitySecurityScanPage = backstagePluginWizPlugin.provide(
  createComponentExtension({
    name: 'EntitySecurityScanPage',
    component: {
      lazy: () =>
        import('./components/SecurityScanTable/SecurityScanTable').then(
          m => m.SecurityScanTable,
        ),
    },
  }),
);
